import React, {useEffect, useRef} from "react"
import {domToReact} from "html-react-parser";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export const ZoomPanPinch = ({node, options}) => {
  const transformComponentRef = useRef(null);

  useEffect(() => {
    const listener = (e) => {
      if (e.detail && e.detail.targetElement) {
        const { zoomToElement } = transformComponentRef.current;
        zoomToElement(e.detail.targetElement);
      }
    }

    document.addEventListener("zoom-pan-pinch-zoom-to-element", listener, false)

    if (!window.zoomPanPinchZoomToElement) {
      window.zoomPanPinchZoomToElement = (targetElement) => {
        const event = new CustomEvent("zoom-pan-pinch-zoom-to-element", { detail: {
            targetElement: targetElement,
          } })
        document.dispatchEvent(event)
      }
    }

    return () => {
      document.removeEventListener("zoom-pan-pinch-zoom-to-element", listener, false)
    }
  }, []);

  console.log("ZoomPanPinch", {
    centerOnInit: node.attribs["data-center-on-init"] ? node.attribs["data-center-on-init"] === "true" : undefined,
    initialScale: node.attribs["data-initial-scale"] ? Number(node.attribs["data-initial-scale"]) : undefined,
    initialPositionX: node.attribs["data-initial-position-x"] ? Number(node.attribs["data-initial-position-x"]) : undefined,
    initialPositionY: node.attribs["data-initial-position-y"] ? Number(node.attribs["data-initial-position-y"]) : undefined,
  })

  return <TransformWrapper
    ref={transformComponentRef}
    centerOnInit={node.attribs["data-center-on-init"] ? node.attribs["data-center-on-init"] === "true" : undefined}
    initialScale={node.attribs["data-initial-scale"] ? Number(node.attribs["data-initial-scale"]) : undefined}
    initialPositionX={node.attribs["data-initial-position-x"] ? Number(node.attribs["data-initial-position-x"]) : undefined}
    initialPositionY={node.attribs["data-initial-position-y"] ? Number(node.attribs["data-initial-position-y"]) : undefined}
  >
    <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }}>
      {domToReact(node.children, options)}
    </TransformComponent>
  </TransformWrapper>
}